import { ECustomPropertyType, IBoardCardCustomOption } from '../../../../../../../store/customProperties/types';
import { TCustomPropertyId } from '../../../../../../../types/types';
import { ICustomPropertiesElement } from '../CustomProperty/types';

export interface ICustomPropertiesFormFields {
    element?: ICustomPropertiesElement;
    isCloseOnAdd?: boolean;
    isNew?: boolean;
    isReadonly?: boolean;
    names?: string[]; // для проверки дубликатов
    isPopup?: boolean;
}

export interface ICustomPropertiesFormEvents {
    onChange: (
        name: string,
        type: ECustomPropertyType,
        options: IBoardCardCustomOption[]
    ) => void;
    onChangeType: (
        type: ECustomPropertyType
    ) => void;
    onClose?: () => void;
    onDropdownOptionsButton?: (button: EDropdownOptionsButtonSource) => void;
    onEnter?: () => void;
    onOptionAdd?: (customPropertyId: TCustomPropertyId, element: ICustomPropertiesElement) => void;
    onSortOptions?: (propertyId: TCustomPropertyId, sourceIndex: number, index: number) => void;
    setNewProperty?: (property: ICustomPropertiesElement) => void;
}

export interface ICustomPropertiesFormProps extends
    ICustomPropertiesFormFields,
    ICustomPropertiesFormEvents
{}

export enum EDropdownOptionsButtonSource {
    ADD = 'add',
    REMOVE = 'remove'
}
